import { create } from 'zustand';
import type { FeatureKey } from '../types';
import type { QuotaRefusal } from '../services/claude';

interface PaywallState {
  visible: boolean;
  feature: FeatureKey | null; // feature à l'origine de l'ouverture → met en avant le plan adapté
  /**
   * Pourquoi le Paywall s'ouvre. `null` = ouverture DÉLIBÉRÉE (l'utilisateur a cliqué « voir les
   * offres ») : aucun refus à expliquer, donc aucun bandeau. Une raison n'est posée que lorsqu'un
   * appel a réellement été refusé.
   */
  reason: QuotaRefusal | null;
  open: (feature?: FeatureKey | null, reason?: QuotaRefusal | null) => void;
  close: () => void;
}

// Store global : permet d'ouvrir le Paywall depuis les hooks (hors React) et n'importe quel écran.
export const usePaywallStore = create<PaywallState>((set) => ({
  visible: false,
  feature: null,
  reason: null,
  open: (feature = null, reason = null) => set({ visible: true, feature, reason }),
  close: () => set({ visible: false, feature: null, reason: null }),
}));
